import { pageHead } from "@/lib/route-head";
import { getAudiencePage } from "@/data/audience-pages";
import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AudienceLanding = lazy(() => import("@/pages/AudienceLanding"));

export const Route = createFileRoute("/entrepreneur-dinners")({
  head: () => { const p = getAudiencePage("entrepreneur-dinners"); return pageHead({ path: "/entrepreneur-dinners", title: p?.title ?? "Amorette", description: p?.description ?? "" }); },
  component: AudienceLanding,
});
